import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® usa anestesia como el TEC?",
    answer:
      "No. SAINT® se administra con el paciente despierto, sin anestesia ni sedación. El TEC (terapia electroconvulsiva) sí suele requerir anestesia. Son tratamientos distintos.",
  },
  {
    question: "¿Para quién es SAINT®?",
    answer:
      "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  },
];

export const esSaintVsEct = makeEsArticle({
  slug: "saint-vs-ect",
  title: "SAINT® frente a TEC (terapia electroconvulsiva)",
  description:
    "Diferencias entre SAINT® TMS y el TEC: anestesia, recuperación, ambiente de tratamiento e indicaciones para el trastorno depresivo mayor.",
  h1: "SAINT® frente a TEC (terapia electroconvulsiva)",
  breadcrumbLabel: "SAINT® vs TEC",
  shortAnswer:
    "SAINT® es una estimulación magnética transcraneal acelerada que se administra con el paciente despierto, sin anestesia ni sedación, en un ambiente ambulatorio durante cinco días. El TEC (terapia electroconvulsiva) usa estimulación eléctrica y suele requerir anestesia y una sala de recuperación. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos; la elegibilidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "SAINT® se administra sin anestesia, con el paciente despierto.",
    "El TEC suele requerir anestesia y una sala de recuperación.",
    "SAINT® usa estimulación magnética; el TEC usa estimulación eléctrica.",
    "SAINT® se completa en cinco días en un ambiente ambulatorio.",
    "Ambos son tratamientos distintos con indicaciones distintas.",
  ],
  sections: [
    {
      heading: "Diferencias clave",
      paragraphs: [
        "SAINT® utiliza estimulación magnética transcraneal acelerada con orientación por fMRI. No usa anestesia ni sedación y se administra en un ambiente ambulatorio durante cinco días consecutivos.",
        "El TEC utiliza estimulación eléctrica para inducir una convulsión terapéutica y suele requerir anestesia general y una sala de recuperación. Ambos son tratamientos para la depresión, pero son procedimientos distintos con mecanismos, entornos y perfiles de efectos distintos.",
      ],
    },
    {
      heading: "Indicación de SAINT®",
      paragraphs: [
        "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones. La decisión entre SAINT® y TEC corresponde al equipo clínico y al paciente tras una evaluación.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "U.S. Food and Drug Administration. 510(k) Premarket Notification — Magnus Neuromodulation System with SAINT Technology (K220177, September 2022).",
      url: "https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/pmn.cfm",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
